import React, { useContext } from 'react';
import { Trans } from '@lingui/macro';
import Pagination from '../pagination/pagination';
import { Properties as ListProperties } from './job-list';
import State from '../state/state';
import { StateContext } from '../state/contexts';
import Job from './types/job';

export type Properties = {
  className?: string;
  itemClassName?: string;
  withImage?: boolean;
  List: React.ComponentType<ListProperties>;
  Card: React.ComponentType<{ job: Job }>;
};

const JobListWithPagination = ({ className, itemClassName, withImage = false, List, Card }: Properties) => {
  const state: State = useContext(StateContext);
  const { jobs } = state;

  return (
    <>
      <div role="status">
        {jobs.fetched.length === 0 && (
          <span>
            <Trans>There are currently no job offers.</Trans>
          </span>
        )}
        {jobs.fetched.length > 0 && jobs.filtered.length === 0 && (
          <span>
            <Trans>There are currently no job offers matching your filter selection.</Trans>
          </span>
        )}
      </div>
      <List className={className} itemClassName={itemClassName} withImage={withImage} jobs={jobs.page} Card={Card} />
      <Pagination />
    </>
  );
};

export default JobListWithPagination;
